import Route from "@/scripts/routeRegistrar"
const RouteRegistrar = new Route('newsletters');

RouteRegistrar.add("newsletters/users/NewslettersUsers", "users", "newsletters-users", "مدیریت اعضای خبرنامه")

const routes = RouteRegistrar.allRoutes()


export default routes;
